import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { CompanyActions, selectCompanyLogoUrl } from '@public-page/store/company';

@Component({
  selector: 'pub-company-logo',
  templateUrl: './company-logo.component.html',
  styleUrls: ['./company-logo.component.scss'],
})
export class CompanyLogoComponent {
  $logoUrl = this.store.select(selectCompanyLogoUrl);
  @Input() small = false;

  constructor(private store: Store) {}

  public redirectToCompanyPage(): void {
    this.store.dispatch(CompanyActions.redirectToCompanyPage());
  }
}
